export var PhoneNumberAmount;
(function (PhoneNumberAmount) {
    PhoneNumberAmount["Single"] = "single";
    PhoneNumberAmount["Multiple"] = "multiple";
})(PhoneNumberAmount || (PhoneNumberAmount = {}));
